import React from 'react';
import { View } from 'react-native';
import { createStackNavigator } from 'react-navigation-stack';
import Theme from '../theme';
import { BackButton } from '../Profile/components/BackButton';
import SwitchMember from './SwitchMember';
import InviteMember from './InviteMember';
import { MemberSetttings } from './MemberSettings';
import { ChooseProfileColor } from './ChooseProfileColor';
import { ConfirmRemove } from './ConfirmRemove';
import { SetProfilePin } from './SetProfilePin';
import { EnterProfilePin } from './EnterProfilePin';
import { ForgotMyPin } from './ForgotMyPin';

const buildSwitchMemberNavigator = () => createStackNavigator(
  {
    SwitchMember: {
      screen: SwitchMember,
      navigationOptions: ({ navigation }) => ({
        headerTitle: () => <View />,
        headerLeft: (
          <BackButton navigation={navigation} color={Theme.PRIMARY} size={20} />
        ),
      }),
    },
    InviteMember: {
      screen: InviteMember,
      navigationOptions: ({ navigation }) => ({
        headerTitle: () => <View />,
        headerLeft: (
          <BackButton navigation={navigation} color={Theme.PRIMARY} size={20} />
        ),
      }),
    },
    MemberSettings: {
      screen: MemberSetttings,
      navigationOptions: ({ navigation }) => ({
        headerTitle: () => <View />,
        headerLeft: () => <BackButton navigation={navigation} color={Theme.PRIMARY} size={20} />,
      }),
    },
    ChooseProfileColor: {
      screen: ChooseProfileColor,
      navigationOptions: ({ navigation }) => ({
        headerTitle: () => <View />,
        headerLeft: () => <BackButton navigation={navigation} color={Theme.PRIMARY} size={20} />,
      }),
    },
    ConfirmRemove: {
      screen: ConfirmRemove,
      navigationOptions: ({ navigation }) => ({
        headerTitle: () => <View />,
        headerLeft: () => <BackButton navigation={navigation} color={Theme.PRIMARY} size={20} />,
      }),
    },
    SetProfilePin: {
      screen: SetProfilePin,
      navigationOptions: ({ navigation }) => ({
        headerTitle: () => <View />,
        headerLeft: () => <BackButton navigation={navigation} color={Theme.PRIMARY} size={20} />,
      }),
    },
    EnterProfilePin: {
      screen: EnterProfilePin,
      navigationOptions: ({ navigation }) => ({
        headerTitle: () => <View />,
        headerLeft: () => <BackButton navigation={navigation} color={Theme.PRIMARY} size={20} />,
      }),
    },
    ForgotMyPin: {
      screen: ForgotMyPin,
      navigationOptions: ({ navigation }) => ({
        headerTitle: () => <View />,
        headerLeft: () => <BackButton navigation={navigation} color={Theme.PRIMARY} size={20} />,
      }),
    },
  },
  {
    defaultNavigationOptions: () => ({
      initialRouteName: 'SwitchMember',
      headerStyle: {
        shadowColor: 'transparent',
        backgroundColor: '#fff',
        elevation: 0,
      },
    }),
  },
);

export default buildSwitchMemberNavigator;
